<template>
  <v-app id="app" class="public-app">
    <v-app-bar
      :class="`fin-public-app-bar ${$vuetify.breakpoint.smAndDown ? '': 'px-6'} fin-color-primary-dark fin-color-primary-light--text`"
      app
      content
      dark
      height="70"
      style="z-index: 20 !important;">
      <v-toolbar-title class="pr-8">
        <router-link id="navHomeLink" to="/home">
          <fin-logo-full :size="this.$valueByBreakpoint({ xs: '105', sm: '133' })"/>
        </router-link>
      </v-toolbar-title>
    </v-app-bar>

    <v-main style="background-color: #fff;">
      <router-view/>
      <fin-cookie-declaration/>
    </v-main>

    <fin-footer v-if="isNotApp && $vuetify.breakpoint.smAndUp"
                :routes="footerRoutes" dark inner />
  </v-app>
</template>

<script>
import FinLogoFull from "@/components/common/logo/LogoFull"
import FinFooter from "@/components/common/footer"
import {Analytics} from '@/plugins/finAmplifyModules'
import FinCookieDeclaration from "@/components/common/FinCookieDeclaration"
import finBrowser from "@/js/finBrowser"

export default {
  name: "finNewsletter",
  components: {FinCookieDeclaration, FinFooter, FinLogoFull},
  data() {
    return {
      footerRoutes: [
        {to: {name: 'finImprint'}, name: 'Impressum', cssID: 'imprint'},
        {to: {name: 'finDataProtection'}, name: 'Datenschutz', cssID: 'gdpr'},
        //{to: {name: 'finAgb'}, name: 'AGB', cssID: 'tou'},
        {to: {name: 'finRiskWarnings'}, name: 'Risikohinweise', cssID: 'risk'}
      ],
      isNotApp: !finBrowser.IS_IOS_OR_ANDROID_APP,
    }
  },
  mounted() {
    Analytics.record({ name: 'newsletterVisit' })
  }
}
</script>

<style scoped>

</style>
